<!-- // 浮框文字提示 -->
<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '300px'
    },
    placement: {
      type: String,
      default: 'top-start'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    _content() {
      let content = this.content.split('\n');
      return content.map(t => t.trim());
    }
  },

  render() {
    const referenceSlot = this.$slots.reference
    const defaultSlot = this.$slots.default
    return (
      <el-tooltip
        popper-class="text-tip"
        effect="light"
        placement={this.placement}
        disabled={this.disabled}
      >
        {/* {referenceSlot ? referenceSlot : <span class="text-tip__handle">?</span>} */}
        {referenceSlot ? referenceSlot : <i class="el-icon-question text-tip__icon"></i>}

        <div
          slot="content"
          class="text-tip__content"
          style={{ maxWidth: this.width }}
        >
          {this._content.map(item => <p domPropsInnerHTML={item}></p>)}

          {defaultSlot ? defaultSlot : null}
          <slot />
        </div>
      </el-tooltip>
    )
  }
}
</script>
